import {
    Box,
    Button,
    Grid,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import InputBase from "@mui/material/InputBase";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../../css/global.css"; // Importa el archivo global.css
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import getColumns from "../../../layout/Columns/ColumnsUsuarios";
import { TablePaginateUsers } from "../../../layout/Datagrid/TablePaginateUsers";
import { Icons } from "../../../layout/Icons";
import { queries } from "../../../queries";
import { catalogoList } from "../../../services/CatalogoServices";
import { rolType } from "../../../types/userTypes";
import { userRolEnum } from "../../../types/enumTypes";
import { Add, AddBox, LibraryAdd } from "@mui/icons-material";

export interface fechaOrNull {
    fecha: string;
}

export default function ListaUsuarios() {
    const USUARIO_STORAGE_KEY: string = "IdUsuario";
    const BASEURL = "/inmuebles/comodato";
    const TITULO = "Usuarios";
    const navigate = useNavigate();
    const [selectedRowIds, setSelectedRowIds] = useState<Array<string>>([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [uuidrow, setUuidRow] = React.useState();
    const [rows, setRows] = useState([]);

    const handleNuevoClick = () => {
        navigate("/comodato/alta");
    };
    const handleNuevoGrupoClick = () => {
        navigate("/comodato-grupo/alta");
    };
    const handleVerClick = (id: string, link: string) => {
        navigate(link + id);
    };

    const columns = getColumns({ handleVerClick, urlOrigen: '/usuarios/listado' });
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(25);
    const [totalRows, setTotalRows] = React.useState(0);

    const getData = async (page?: number) => {
        setDataLoading(true)
        var response = await axios({
            method: "get",
            params: {
                IdApp: localStorage.getItem("IdApp"),
            },
            url: process.env.REACT_APP_APPLICATION_LOGIN_BACK + "/api/users-app",
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("jwtToken") || "",
            },
        })
            .then(({ data }) => {
                setDataLoading(false);
                if (data.data) {
                    setRows(data.data)
                } else {
                    setDataLoading(false)
                    return false;
                }
                return true;
            })
            .catch(function (error) {
                setRows([]);
                setDataLoading(false)
                return false;
            });
        return response;
    };

    useEffect(() => {
        getData(currentPage);
    }, []);

    const datosTest = [
        { uuid: "11", nombre: "Jose", correo: "correo@mail.com" },
        { uuid: "12", nombre: "Maria", correo: "Maria@mail.com" },
        { uuid: "13", nombre: "Jona", correo: "Jona@mail.com" },
        { uuid: "14", nombre: "Pepe", correo: "Pepe@mail.com" },
    ]

    return (
        <Grid container sx={{}}>
            <Grid sx={{}} item xs={12}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid container>
                <Grid item xs={12} md={1} mt={1}>
                    <Typography
                        variant="h5"
                        component="div"
                        sx={{
                            flexGrow: 1,
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "left",
                        }}
                    >
                        {TITULO}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} md={1} lg={2} mt={1}>
                    <Tooltip title="Alta Usuarios">
                        <Button
                            onClick={() => navigate('/admin/configuracion/usuarios/alta')}
                            sx={{ marginLeft: "5px", textTransform: "capitalize" }}
                            variant="contained"
                            size="small"
                        >
                            <Add /> Agregar
                        </Button>
                    </Tooltip>
                </Grid>

                <Grid
                    sx={{
                        justifyContent: "center",
                        paddingTop: "1px",
                        height: "8px",
                        display: "",
                    }}
                    item
                    xs={12}
                    md={12}
                    mt={2}
                ></Grid>
            </Grid>

            <TablePaginateUsers
                rowsInfo={rows}
                columns={columns}
                asignarEnlaces={() => {
                    return 0;
                }}
                selectedOptions={{ selected: false }}
                Mostrar={false}
                loading={dataLoading}
                checkboxActive={false}
                exportFile={false}
                camposCsv={[]}
                pageSize={perPage}
            />
        </Grid >
    );
}
